module.exports = __webpack_public_path__ + "img/style_swiper_03.0f597efa.png";